// API Configuration — Web version
// Uses relative URLs so requests go through the same origin (proxied via Cloudflare Pages)
export const API_CONFIG = {
  BASE_URL: '/api',
};
